import React, {Component} from 'react';

// import Custom Componenets
// import Breadcrumb from '../components/common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Select from 'react-select';

// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

// koneksi
import {Post, Get, Delete, JENIS_DESA} from '../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { DataToken } from '../function/Format';




const frmDef = {
    uuid: '',
    jabatan  : '',
    jabatan_pengganti  : '',
    nama  : '',
    nip  : '',
    status  : '',
}
class BasicTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pagination: [],
            status: {
                form:false,
                btnForm:false,
                btnAksi:false
            },
            awal: "",
            sebelum: "",
            hal: [],
            setelah: "",
            akhir: "",
            dt:frmDef,
						loading: false,
            judul: "Tambah Tanda Tangan",
            // =========== Select 2 ============
            frmPrg: [],
            statusStat: [],
            prgStat: [],
            prgStat2: [],
            // =================================
            alert:null,
            show: false,
            basicTitle:'',
            basicType:"default",
            pesanAlert:'',
            // =================================
            frmPengganti: 'none',
            akun: DataToken(sessionStorage.getItem('access_token')),

            
			isKelurahan: false,
        };
    }
    
    // ================== Sweet Alert ==================
    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    onRecieveInput = (value) => {
        this.setState({
            alert: (
                <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
                    You wrote: {value}
                </SweetAlert>
            )
        });
    }

    hideAlert = () => {
        this.setState({
            alert: null
        });
    }

    // =================================================

    // ================== Ambil data dari db untuk table ==================
    fetch = (params = {}) => 
    {    
				this.setState({ loading: true })
        let link = "";
        // let where = [];
        // if (params.where)
        // {
        //     where = params.where;
        // }
        if (params.page)
        {
            switch(params.page)
            {
                case '>>': link = "?page="+(Math.ceil(this.state.pagination.total / this.state.pagination.per_page));break;
                case '>': link = "?page="+(parseInt(this.state.pagination.current_page) + 1);break;
                case '<': link = "?page="+(parseInt(this.state.pagination.current_page) - 1);break;
                case '<<': link = "?page=1";break;
                default: link = "?page="+params.page;break;
            }
        }
        Get('tanda-tangan'+link, null, (dtkat) => {
            this.setState({data:dtkat.results.data, pagination:dtkat.results, loading: false});
            this.pagination(dtkat.results);
        });
    }
    
    // Pagination
    pagination = (data) => {
        // const data = this.state.pagination;
        //console.log(data);
        let awal = "";
        let hal = [];
        let sebelum = "";
        let setelah = "";
        let akhir = "";
        if (data.total > 0)
        {
            let start = 1;
            let end = 5;
            let n = 0;
            let p = 0;
            if (data.current_page <= 3)
            {   
                start = 1;
                end = 5;
                if (data.last_page > data.current_page)
                {
                    n = data.current_page + 1;
                }
            }
            else 
            {
                p = data.current_page - 1;
                n = data.current_page + 1;
                start = data.current_page - 2;
                end = data.current_page + 2;
            }
            if (end >= data.last_page - 2)
            {
                p = data.current_page - 1;
                if (start >= 5)
                {
                    start = data.last_page - 4;
                }
                end = data.last_page;
            }
    
            for (let i=start;i<=end;i++) 
            {
                let warna = "primary-custom";
                if (i === data.current_page)
                {
                    warna = "danger"
                }
                hal.push(<a href={() => false} onClick={()=>this.fetch({page:i})} className={"btn btn-"+warna+" btn-square btn-sm pr-3 pl-3 pt-2 pb-2"}>{i}</a>)
            }
            if (p > 0)
            {
                sebelum = (<a href={() => false} onClick={()=>this.fetch({page:p})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<"}</a>)
            }
            if (n > 0)
            {
                setelah = (<a href={() => false} onClick={()=>this.fetch({page:n})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">"}</a>)
            }
            awal = (<a href={() => false} onClick={()=>this.fetch({page:1})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<<"}</a>)
            akhir = (<a href={() => false} onClick={()=>this.fetch({page:data.last_page})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">>"}</a>)
        }
        this.setState({awal,sebelum,hal,setelah,akhir});
    }
    // Cari Data Table
    cariData = e => {
        if (e.key === "Enter")
        {
            let addTandaTangan = {
                nama : e.target.value,
            };
            Post('tanda-tangan',null, addTandaTangan, (data) => {
                this.setState({data:data.data.results.data, pagination:data.data.results});
            });
        }
    }

    // ========================================================================

    // ================== simpan data ==================
    simpan = e => {
        e.preventDefault();
        let jabatan_ttd = '';
        if(this.state.isKelurahan){
            jabatan_ttd = "Kepala Kelurahan";
        }
        else{
            jabatan_ttd = "Kepala Desa";
        }
        // if (this.state.prgStat)
        if (jabatan_ttd)
        {
            this.setState({
                status:{
                    ...this.state.status,
                    btnForm: true,
                }
            })
            this.forceUpdate();
            let addTandaTangan = {
                uuid : document.getElementById("uuid").value,
                nip : document.getElementById("nip").value,
                nama : document.getElementById("nama").value,
                aktif : document.getElementById("aktif").value,
                status : this.state.statusStat?this.state.statusStat.value:null,
                // jabatan : this.state.prgStat?this.state.prgStat.value:null,
                jabatan : jabatan_ttd,
                jabatan_pengganti : this.state.prgStat2?this.state.prgStat2.value:null,
            };
            
            let psn = '';
            let resstat = 204;
            let metode = "create";
            if (addTandaTangan.uuid === '')
            {
                psn = "Tambah"; 
                resstat = 201;
                addTandaTangan.uuid = null;
                
            } 
            else 
            {
                psn = "Ubah"; 
                resstat = 200;
                metode = "update";
            }
            Post('tanda-tangan/'+metode,addTandaTangan.uuid,addTandaTangan, (res) => {
                this.setState({
                    status:{
                        ...this.state.status,
                        btnForm: false,
                        form: false,
                    }
                })
                this.forceUpdate();
                if (res.status === resstat)
                {
                    this.setState({ show: true, basicType:'success', basicTitle:'Data Tanda Tangan', pesanAlert:'Berhasil '+psn+' Data' });
                }
                else
                {
                    this.setState({ show: true, basicType:'danger', basicTitle:'Data Tanda Tangan', pesanAlert:'Gagal '+psn+' Data' });
                }
                this.componentDidMount();
            });
        }
        else 
        {
            this.setState({ show: true, basicType:'danger', basicTitle:'Data Tanda Tangan', pesanAlert:'Jabatan Harus diisi' });
        }
    }
    // ========================================================================
    
    // ============================== Ubah Data ===============================
    
    ubahData = (id) => {
        this.setState({
            status:{
                ...this.state.status,
                btnAksi: true,
            },
            judul: "Ubah Tanda Tangan",
        })
        this.forceUpdate();
        Get('tanda-tangan/find',id, (data) => {
            this.setState({
                dt: data.results,
                prgStat: "Kepala Desa",
                prgStat2: {value:data.results.jabatan_pengganti, label:data.results.jabatan_pengganti},
                statusStat: {value:data.results.status, label:data.results.status},
            })
            // this.state.prgStat = {value:data.results.jabatan, label:data.results.jabatan};
            if(data.results.jabatan_pengganti && data.results.status){
                this.setState({
                    frmPengganti: "inherit",
                })
            }
            else{
                this.setState({
                    frmPengganti: "none",
                })
            }
            this.setState({
                status:{
                    ...this.state.status,
                    btnAksi: false,
                }
            })
            this.bukaForm();
        });
    }
    // ========================================================================
    // ============================= Hapus Data ===============================
    konfirmHapus = (id) => {
        this.setState({
            alert: (
                <SweetAlert
                    showCancel
                    confirmBtnText="Hapus"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="success"
                    type="danger"
                    title="Yakin ingin hapus data ?"
                    onCancel={this.hideAlert}
                    onConfirm={()=> this.hapusData(id)}
                >
                    Proses ini tidak dapat dibatalkan!
                </SweetAlert>
            )
        });
    }

    hapusData = (id) => {
        this.hideAlert();
        let psn = "Hapus";
        Delete('tanda-tangan/delete', id, (res) => {
            if (res === 200)
            {
                this.setState({ show: true, basicType:'success', basicTitle:'Data Tanda Tangan', pesanAlert:'Berhasil '+psn+' Data' });
            }
            else
            {
                this.setState({ show: true, basicType:'danger', basicTitle:'Data Tanda Tangan', pesanAlert:'Gagal '+psn+' Data' });
            }
            this.componentDidMount();
        })
    }
    // ========================================================================

    formPengganti = e => {
        e.preventDefault();
        if (this.state.frmPengganti === "none")
        {
            this.setState({frmPengganti:"inherit"});
        }
        else 
        {
            this.setState({frmPengganti:"none"});
        }
    }
    bukaForm = () => {
        this.setState({
            status:{
                ...this.state.status,
                form: true,
            }
        })
        this.forceUpdate();
    }

    tutupForm = () => {
        this.setState({
            status:{
                ...this.state.status,
                form: false,
            }
        })
        this.forceUpdate();
    }

    tombolAksi = (cell, row) => {
        return (
            <>
                <Button  size="xs" color="success" className="btn-icon" onClick={() => this.ubahData(row.uuid)} disabled={this.state.status.btnAksi}><i className="fa fa-pencil"></i></Button> &nbsp;&nbsp;
								{this.state.akun.sub.data_role.nama_role === "Super Admin" ? (
									<Button  size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmHapus(row.uuid)} disabled={this.state.status.btnAksi}><i className="fa fa-trash"></i></Button>
								) : ''}

            </>
        )
    }

    changeSelectValue = (e,sel) =>
    {
        if (e){
            switch(sel)
            {
                case 'status': 
                    this.setState({
                        statusStat:e,
                        dt:{
                            ...this.state.dt,
                            status: e.value,
                        }
                    }); 
                    break;
                case 'jabatan': 
                    this.setState({
                        prgStat:e,
                        dt:{
                            ...this.state.dt,
                            jabatan: e.value,
                        }
                    }); 
                    break;
                case 'jabatan_pengganti': 
                    this.setState({
                        prgStat2:e,
                        dt:{
                            ...this.state.dt,
                            jabatan_pengganti: e.value,
                        }
                    }); 
                    break;
                default:
                    // no default
                    break;
            }
        }
        else 
        {
            switch(sel)
            {
                case 'status': 
                    this.setState({
                        statusStat:e,
                        dt:{
                            ...this.state.dt,
                            status: e.value,
                        }
                    }); 
                    break;
                case 'jabatan': 
                    this.setState({
                        prgStat:e,
                        jabatan: 0,
                    }); 
                    break;
                case 'jabatan_pengganti': 
                    this.setState({
                        prgStat:e,
                        dt:{
                            ...this.state.dt,
                            jabatan_pengganti: 0,
                        }
                    }); 
                    break;
                default:
                    // no default
                    break;
            }
        }
        this.forceUpdate();
    }
    componentDidMount() {
        this.fetch({page:null,where:[]});
        Get('jabatan-perangkat/list', null, (data) => {
            let frmPrg = [];
            data.results.forEach((dt) => {
                frmPrg.push({value:dt.nama, label:dt.nama});
            });
            this.setState({frmPrg});
        })
        Get('select-enum/tanda_tangan/status', null, (data) => {
            let frmStatus = [];
            data.forEach((dt) => {
                frmStatus.push({value:dt, label:dt});
            });
            this.setState({frmStatus});
        })

        if (JENIS_DESA.toLowerCase() === 'kelurahan') {
			this.setState({ isKelurahan: true });
        }
    }

    render() {
        // var size = Math.ceil(this.state.pagination.total / this.state.pagination.per_page);
        // var size = this.state.pagination.total;
        // var from = this.state.pagination.from;
        // var page = this.state.pagination.current;
        // var to = this.state.pagination.to;
        // var total = this.state.pagination.total;
        var data = this.state.data;
        const frmDef = {
            uuid: '',
            jabatan  : '',
            jabatan_pengganti  : '',
            nama  : '',
            nip  : '',
            status  : '',
        }
        // const { SearchBar } = Search;
        const columns = [
            {
                dataField: "no",
                text: "No",
                headerAlign: 'center',
								align: 'center',
                formatter: (key, obj, index) =>{          
                    let current_pagenum = this.state.pagination.current_page;
                    let total_records_per_page = this.state.pagination.per_page;
                    let row_index = (index+1);
                    let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
                    return serial_num; 
                }
            },
            {
                dataField: 'nip',
                text: 'NIP',
								headerAlign: 'center',
								align: 'center',
                sort: true
            },
            {
                dataField: 'nama',
                text: 'Nama',
								headerAlign: 'center',
								align: 'center',
                sort: true
            },
            {
                dataField: 'jabatan',
                text: 'Jabatan',
								headerAlign: 'center',
								align: 'center',
                sort: true
            },
            {
                dataField: 'status',
                text: 'Status',
								headerAlign: 'center',
								align: 'center',
                sort: true
            },
            {
                dataField: 'jabatan_pengganti',
                text: 'Jabatan Pengganti',
								headerAlign: 'center',
								align: 'center',
                sort: true
            },
            {
                dataField: 'aktif',
                text: 'Utama',
                isDummyField: true,
								headerAlign: 'center',
								align: 'center',
                formatter: (cell, data) => data.aktif==="1"?"Ya":"Tidak",
                sort: true
            },
            {
                dataField: 'aksi',
                text: 'Aksi',
                headerAlign: 'center',
								align: 'center',
                formatter: this.tombolAksi,
            },
        ];

        // const defaultSorted = [{
        //     dataField: 'nama',
        //     order: 'asc'
        // }];

        // const pageButtonRenderer = ({
        //                                 page,
        //                                 active,
        //                                 disable,
        //                                 title,
        //                                 onPageChange
        //                             }) => {
        //     const handleClick = (e) => {
        //         e.preventDefault();
        //         this.fetch({where:[],page:page});
        //     };
        //     var classname = '';
        //         classname = 'btn btn-success';
        //     return (
        //         <li className="page-item pl-1" key={page}>
        //             <a href={() => false} onClick={ handleClick } className={ classname }>{ page }</a>
        //         </li>
        //     );
        // };

        // const options = {
        //     alwaysShowAllBtns:true,
        //     pageButtonRenderer,
        //     // custom: true,
        //     paginationTotalRenderer: () => (
        //         <span className="react-bootstrap-table-pagination-total">
        //             Showing { from } to { to } of { total } Results
        //         </span>
        //     ),
        //     paginationSize: size, 
        //     totalSize: total
        //   };

        return (
            <div>
                {/* <Breadcrumb title="Data Tanda Tangan" parent="Admin"/> */}
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    confirmBtnBsStyle="success"
                    onConfirm={this.closeAlert}
										style={{ maxWidth: "478px" }}
                >
                    {this.state.pesanAlert}
                </SweetAlert>

                {this.state.alert}

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card mb-0">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h5>Data Tanda Tangan</h5>
                                            {/* <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span> */}
                                        </div>
                                        <div className="col-sm-6 text-right">
                                            <Button  size="sm" color="success" className="btn-square" onClick={()=>{ this.setState({judul:"Tambah Tanda Tangan", dt:frmDef, statusStat:null, prgStat:null, prgStat2:null});this.bukaForm();}}>Tambah Data</Button>                                                  
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body datatable-react">
																	{this.state.loading ? (
																		<div className="row">
																			<div className="col-sm-12" align="center">
																				<img
																					alt="loading"
																					src={require("../assets/images/tes-loading.gif")}
																					style={{
																						borderRadius: "10px",
																						width: '100px'
																					}} />
																			</div>
																		</div>
																	) : data.length > 0 ? (
																		<>
                                    <BootstrapTable
                                        keyField="id"
                                        data={ data }
                                        columns={ columns }
                                        />
                                    <div className="pull-right text-white">
                                        {this.state.awal}{this.state.sebelum}{this.state.hal.map(dt=> { return dt})}{this.state.setelah}{this.state.akhir}
                                    </div>
																		</>
																	) : (
																		<h6 className="text-center mb-2 mt-2">Belum ada data</h6>
																	)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <Modal open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
                    <Form className="theme-form" onSubmit={this.simpan}>
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.judul}</h5>
                        </div>
                        <div className="modal-body">
                            <p>Nama Penanda Tangan otomatis terisi saat memilih jabatan dari perangkat {JENIS_DESA.toLowerCase()}. Namun nama ini bisa diubah sesuai kebutuhan. Misalkan untuk menambahkan gelar depan dan belakang</p>
                            <input className="form-control" id="uuid" type="hidden" placeholder="TandaTangan" defaultValue={this.state.dt.uuid}/>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jabatan</Label>
                                <Col sm='9'>
                                    <input className="form-control" id="jabatan_ttd" type="text" placeholder="Nama Penanda Tangan" defaultValue={this.state.isKelurahan?"Kepala Kelurahan":"Kepala Desa"} required readOnly/>
                                    {/* <Select
                                        classNamePrefix="select"
                                        onChange={((e)=>{ this.changeSelectValue(e,'jabatan')})}
                                        defaultValue={this.state.prgStat} 
                                        value={this.state.prgStat} 
                                        name="jabatan"
                                        options={this.state.frmPrg}
                                        placeholder="Pilih Jabatan Penanda Tangan"
                                        isClearable
                                        /> */}
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Col sm={12}>
                                    <a href={() => false} onClick={this.formPengganti} className="btn btn-xs btn-success">Pengganti</a>
                                </Col>
                            </FormGroup>
                            <div style={{display:this.state.frmPengganti,border:"1px #d2d2d2 solid"}} className="p-3 mb-3 mt-3">
                                <FormGroup className="row">
                                    <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Status</Label>
                                    <Col sm='9'>
                                        <Select
                                            classNamePrefix="select"
                                            onChange={((e)=>{ this.changeSelectValue(e,'status')})}
                                            defaultValue={this.state.statusStat} 
                                            value={this.state.statusStat} 
                                            name="status"
                                            options={this.state.frmStatus}
                                            placeholder="Pilih Jabatan Penanda Tangan"
                                            isClearable
                                            />
                                    </Col>
                                </FormGroup>
                                <FormGroup className="row">
                                    <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Jabatan Pengganti</Label>
                                    <Col sm='9'>
                                        <Select
                                            classNamePrefix="select"
                                            onChange={((e)=>{ this.changeSelectValue(e,'jabatan_pengganti')})}
                                            defaultValue={this.state.prgStat2} 
                                            value={this.state.prgStat2} 
                                            name="jabatan_pengganti"
                                            options={this.state.frmPrg}
                                            placeholder="Pilih Jabatan Pengganti Penanda Tangan"
                                            isClearable
                                            />
                                    </Col>
                                </FormGroup>
                            </div>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Penanda Tangan</Label>
                                <Col sm='9'>
                                    <input className="form-control" id="nama" type="text" placeholder="Nama Penanda Tangan" defaultValue={this.state.dt.nama} required/>
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">NIP Penanda Tangan</Label>
                                <Col sm='9'>
                                    <input className="form-control" id="nip" type="text" placeholder="Kosongkan Jika Non PNS" defaultValue={this.state.dt.nip}/>
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Tanda Tangan Utama</Label>
                                <Col sm='9'>
                                    <select className="form-control" id="aktif" defaultValue={this.state.dt.aktif}>
                                        <option value="1">Ya</option>
                                        <option value="0">Tidak</option>
                                    </select>
                                </Col>
                            </FormGroup>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
                            <button type="submit" className="btn btn-success" disabled={this.state.status.btnForm}>Simpan</button>
                        </div>
                    </Form>
                </Modal>
            </div>
        )
    }
}


export default BasicTable;
